/* eslint-disable @nx/enforce-module-boundaries */
import React from 'react';
import * as Styled from './MActionItemsList.styles';
import { AIcon, AIconSize } from '@marriott/mi-web-ui-kit';

interface MActionItemsListProps {
  activeDropdown: boolean;
  onRename: () => void;
  onDelete: () => void;
  onNewChat?: () => void;
  component?: 'header' | string;
}

export const MActionItemsList: React.FC<MActionItemsListProps> = ({
  activeDropdown,
  onRename,
  onDelete,
  onNewChat,
  component,
}) => {
  const isHeader = component === 'header';

  return (
    <Styled.Wrapper $isHeader={isHeader}>
      {activeDropdown && (
        <Styled.ActionsDropdown $isHeader={isHeader} role="menu" onClick={e => e.stopPropagation()}>
          {component === 'header' && (
            <Styled.NavListAction type="button" role="menuitem" onClick={onNewChat}>
              <Styled.Action>
                <AIcon icon="icon-chat" size={AIconSize.S} iconClass="icon-inverse" />
                <span className="text-inverse t-font-xs">New Chat</span>
              </Styled.Action>
            </Styled.NavListAction>
          )}
          <Styled.NavListAction type="button" role="menuitem" onClick={onRename}>
            <Styled.Action>
              <AIcon icon="icon-edit" size={AIconSize.S} iconClass="icon-inverse" />
              <span className="text-inverse t-font-xs">Rename</span>
            </Styled.Action>
          </Styled.NavListAction>
          <Styled.NavListAction type="button" role="menuitem" onClick={onDelete} className="d-block">
            <Styled.Action>
              <AIcon icon="icon-delete" size={AIconSize.S} iconClass="icon-inverse" />
              <span className="text-inverse t-font-xs">Delete</span>
            </Styled.Action>
          </Styled.NavListAction>
        </Styled.ActionsDropdown>
      )}
    </Styled.Wrapper>
  );
};
